import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "choice-confirm-order" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = {
  class: "table-tr",
  style: {"border-bottom":"1px solid #F0F0F0","margin-bottom":"8px"}
}
const _hoisted_4 = { class: "table-content" }
const _hoisted_5 = {
  key: 0,
  class: "title flex-ter"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "line--2" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  style: {"word-break":"break-all"}
}
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }
const _hoisted_13 = {
  key: 6,
  style: {"color":"#FE2C55"}
}
const _hoisted_14 = { class: "line--3" }
const _hoisted_15 = { style: {"max-width":"300px"} }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  style: {"padding":"0 20px"},
  class: "rel"
}
const _hoisted_18 = { class: "abs shop-mode" }
const _hoisted_19 = { class: "shop-mode-item" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = { class: "shop-mode-item" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "text" }
const _hoisted_25 = { class: "shop-mode-item" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = {
  key: 0,
  class: "text-lt flex-col"
}
const _hoisted_29 = {
  class: "mr_5 mb_5",
  style: {"white-space":"nowrap"}
}
const _hoisted_30 = {
  class: "flex-ter mb_10",
  style: {"color":"#000000A6"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { montageAddition } from '@/util/calcAdt'
import { formatMoney } from '@/plugins/utils'
import { t, message } from '@/plugins/i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { tableColumns } from './data'
import QuestionMark from '@/components/IconPark/QuestionMark.vue'
import { isD2C, isJA, isEN } from '@/store'
import FigurePay from '../FigurePay.vue'
import Recharge from './Recharge.vue'
import { getWallet } from '@/apis/user'
import { purchaseCfg } from '@/apis/setup'
import { getShipIdApi, createOrder } from '@/apis/shopcart'
import CreateOrderSuccess from './CreateOrderSuccess.vue'
import { request } from '@/config/request/interceptors'

export default /*#__PURE__*/_defineComponent({
  props: ['modeConfig', 'modeValue', 'list', 'transportType', 'choiceTotalAmount', 'choiceFn', 'addressValid'],
  emits: ['success'],
  setup(__props, { expose, emit: emits }) {

const props = __props
const store = useStore()
const shopname = computed(() => store.getters.shopname)
const visible = ref(false)
const rechargeRef = ref()


const orderCode = ref('')
const open = () => {
  figurePayRef.value && (figurePayRef.value.inviteCode = '')
  visible.value = true
}
expose({
  open
})
const createOrderSuccessRef = ref()
const loading = ref(false)
const submitPay = async () => {
  if (loading.value) return
  loading.value = true
  // 确定钱包余额
  const wallet = await getBalance().finally(() => {
    loading.value = false
  })
  // if (props.choiceTotalAmount.totalPriceCNY > wallet) {
  //   // 余额不足 去充值
  //   rechargeRef.value.open()
  //   loading.value = false
  //   return
  // }
  const { modeConfig, addressValid, transportType } = props
  let [deliverAddress, clear]: any[] = [{}, () => { }]
  if (modeConfig.value) {
    [deliverAddress, clear] = await addressValid()
  }
  const { purchasePriceAdd } = await purchaseCfg().then((res) => res.data)
  const priceFloatPercent = purchasePriceAdd ?? 0
  const data: any = {
    estimatedTotalOrderPrice: props.choiceTotalAmount.totalPriceCNY,
    cartIdList: props.list.map(v => v.cartId),
    orderType: modeConfig.value ? 1 : 2,
    priceFloatPercent,
    customerOrderNo: orderCode.value,
    allIncludeFlag: 1
  }
  data.deliverAddress = {}
  if (modeConfig.value) {
    const { deliveryAdditionalList, ...rest } = deliverAddress
    data.deliverAddress = rest
  }
  data.deliverAddress.transportType = transportType
  const resData = await getShipIdApi({
    customerId: store.getters.user?.customerId,
    transportType,
    systemSource: isD2C() ? 1 : 2,
    productList: props.list.map(v => ({
      productSku: v.productSku,
      adaptType: v.season,
      num: v.orderQuantity
    }))
  })
  if (!resData.data?.intShipConfigId) {
    ElMessage.warning(t('重量不足，无可用物流'))
    loading.value = false
    return
  }
  data.deliverAddress.intShipConfigId = resData.data.intShipConfigId
  data.recommendCode = (figurePayRef.value.inviteCode || '').trim()
  const res = await request.order.cart.createOrder(data).finally(() => {
    loading.value = false
  })
  if (res.code === '22010002' || res.data?.find(i => i.code === '22010002')) {
    rechargeRef.value.open()
    loading.value = false
    return
  }
  if (res.data?.find(i => i.code === '260000001') || res.code === '260000001') {
    ElMessageBox.confirm(t('当前商品价格发生变化，请确认后决定是否下单'), t('提示'), {
      confirmButtonText: t('关闭2'),
      showCancelButton: false,
      showClose: false,
      type: 'warning'
    }).then(async () => {
      visible.value = false
      await props.choiceFn.getChoiceList(undefined, true)
      await props.choiceFn.calcCheckPrice()
    })
    return
  }

  if (isJA()) {
    if (res.data?.every(v => v.success)) {
      localStorage.setItem('ckb_last_order_id', String(res.data?.[0]?.platformOrderId))
      if (res.data?.some(v => v.firstOrderFlag)) {
        window.location.href = '/order_complete_first?allIncludeFlag=1'
        return
      } else {
        window.location.href = '/order_complete?allIncludeFlag=1'
        return
      }
    }
  }
  createOrderSuccessRef.value.open(res)
  loading.value = false
  emits('success')
}
const shopWallet = ref(0)
const getBalance = async () => {
  const wallet = await getWallet({
    customerShopId: store.getters.curShop,
    currencyCode: 'CNY'
  }).then((res) => res.data.availableAmount)
  shopWallet.value = wallet
  return wallet
}
const figurePayRef = ref()
const paySuccess = async () => {
  await getBalance()
  submitPay()
}
const goodsList = computed(() => {
  const list = [...props.list]
  list.forEach(async (item) => {
    console.log('goodsList', await props.choiceFn.getPriceTypeInfo(item.season))
    item.priceType = (await props.choiceFn.getPriceTypeInfo(item.season))?.name
  })
  return list
})

const scrollHeight = ref(380)
onMounted(() => {
  const height = document.body.offsetHeight - 500
  scrollHeight.value = height > 380 ? 380 : height
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: _unref(t)('确认订单信息'),
      direction: "btt",
      "custom-class": "choice-confirm-order-drawer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableColumns), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "table-th",
                key: index,
                style: _normalizeStyle({ width: item.confirmWidth + 'px' })
              }, _toDisplayString(item.label), 5))
            }), 128))
          ]),
          _createVNode(_component_el_scrollbar, {
            height: `${scrollHeight.value}px`,
            always: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goodsList), (goods, k) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "table-tr",
                    key: k
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableColumns), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "table-td",
                        key: index,
                        style: _normalizeStyle({ width: item.confirmWidth + 'px' })
                      }, [
                        (item.name === 'title')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("img", {
                                src: goods.productSkuImg ?? goods.productMainImg,
                                alt: ""
                              }, null, 8, _hoisted_6),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(goods.productTitleJp), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.name === 'customSku')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(goods.customerProductMsku ?? '-'), 1))
                          : _createCommentVNode("", true),
                        (item.name === 'sku')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(goods.productSku), 1))
                          : _createCommentVNode("", true),
                        (item.name === 'amount')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(goods.orderQuantity), 1))
                          : _createCommentVNode("", true),
                        (item.name === 'priceType')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(goods.priceType), 1))
                          : _createCommentVNode("", true),
                        (item.name === 'allPrice')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(formatMoney)(goods.allIncludePriceResult?.allIncludeProductPriceExchange) || '-'), 1))
                          : _createCommentVNode("", true),
                        (item.name === 'totalPrice')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(formatMoney)(goods.allIncludePriceResult?.allIncludeProductTotalPriceExchange) || '-'), 1))
                          : _createCommentVNode("", true),
                        (item.name === 'adt')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                              (goods.additionNameJpSummary)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 0,
                                    placement: "top",
                                    effect: "light"
                                  }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(montageAddition)(goods.cartAdditionList)), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(montageAddition)(goods.cartAdditionList)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (!goods.cartAdditionList?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(t)('无')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 4))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["height"]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('购买店铺')) + "：", 1),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(shopname)), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('购买类型')) + "：", 1),
                _createElementVNode("span", _hoisted_24, _toDisplayString(__props.modeConfig?.label), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)('运输方式')) + "：", 1),
                _createElementVNode("span", _hoisted_27, _toDisplayString(__props.transportType === 1 ? _unref(t)('海运') : _unref(t)('空运')), 1)
              ]),
              (true || __props.modeConfig?.value || !_unref(isD2C)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createTextVNode(_toDisplayString(_unref(t)(_unref(isD2C)() ? '自定义订单编号' : '订单标题')) + " ： ", 1),
                        _createVNode(_component_el_tooltip, {
                          effect: "light",
                          placement: "top",
                          "popper-class": "tool-tip-no-border"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle({ maxWidth: _unref(isJA)() ? '340px' : _unref(isEN)() ? '380px' : '340px' })
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)('用于识别不同订单。')), 1),
                              _hoisted_31,
                              _createTextVNode(" " + _toDisplayString(_unref(t)('您可以直接引用自家店铺的客户订单号，')), 1),
                              _hoisted_32,
                              _createTextVNode(" " + _toDisplayString(_unref(t)('也可以另外输入文字区分您的订单。')), 1),
                              _hoisted_33,
                              _hoisted_34,
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('例）')), 1),
                                _createElementVNode("div", null, [
                                  _createTextVNode(_toDisplayString(_unref(t)('＜店铺订单号＞ 503-0575395-6075865')), 1),
                                  _hoisted_36,
                                  _createTextVNode(" " + _toDisplayString(_unref(t)('＜订单标题＞ 2024年1月24日李先生的订单已读')), 1)
                                ])
                              ])
                            ], 4)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(QuestionMark, {
                              size: 14,
                              color: "#333"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_el_input, {
                      modelValue: orderCode.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderCode).value = $event)),
                      maxlength: "30"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(FigurePay, {
              confirm: true,
              mode: __props.modeValue,
              "is-choice": true,
              choiceTotalAmount: __props.choiceTotalAmount,
              onCommit: submitPay,
              loading: loading.value,
              ref: (_value, _refs) => {
                _refs['figurePayRef'] = _value
                figurePayRef.value = _value
              },
              showInviteCode: true
            }, null, 8, ["mode", "choiceTotalAmount", "loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(Recharge, {
      ref: (_value, _refs) => {
        _refs['rechargeRef'] = _value
        rechargeRef.value = _value
      },
      choiceTotalAmount: __props.choiceTotalAmount,
      shopWallet: shopWallet.value,
      onSuccess: paySuccess
    }, null, 8, ["choiceTotalAmount", "shopWallet"]),
    _createVNode(CreateOrderSuccess, {
      ref: (_value, _refs) => {
        _refs['createOrderSuccessRef'] = _value
        createOrderSuccessRef.value = _value
      }
    }, null, 512)
  ]))
}
}

})